import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = defineStore('ui', () => {
  const isLoading = ref(false)

  function startLoading() {
    isLoading.value = true
  }

  function finishLoading() {
    isLoading.value = false
  }

  return { isLoading, startLoading, finishLoading }
})
